module.exports = __webpack_public_path__ + "img/chart-vector.1e1a6228.svg";